import { generateVariantData } from '../../../../experiments/utils';

const kidsCreatorsData = {
  title: 'Kids Become Creators',
  subtitle:
    'Kids can build their own games while growing confidence & coding skills. Check out these real projects created by codeSpark kids.',
  carousel: [
    {
      img: 'sorry_glitch_trap.png',
      title: 'Sorry! Glitch Trap',
      icon: 'profile_SparksDragonnormous@2x.svg',
      poster: 'by Sparks Dragonnormous',
      played: '705',
      liked: '124',
      remixed: '134',
      borderColor: '#C8EAC8',
    },
    {
      img: 'search_happy_village.png',
      title: 'Search Happy Village',
      icon: 'profile_CaptainFuzzyface@2x.svg',
      poster: 'by Captain Fuzzyface',
      played: '14902',
      liked: '867',
      remixed: '718',
      borderColor: '#FFF0B3',
    },
    {
      img: 'hey_foo_town.png',
      title: 'Hey! Foo Town',
      icon: 'profile_SparksDragonnormous@2x.svg',
      poster: 'by Sparks Dragonnormous',
      played: '2056',
      liked: '214',
      remixed: '147',
      borderColor: '#FFDBCC',
    },
    {
      img: 'endless_forgotten_world.png',
      title: 'Endless Forgotten World',
      icon: 'profile_BenTurbopaws@2x.svg',
      poster: 'by Ben Turbopaws',
      played: '26136',
      liked: '1868',
      remixed: '1049',
      borderColor: '#BADDF7',
    },
    {
      img: 'catch_the_glitch.png',
      title: 'Catch the Glitch',
      icon: 'profile_MasterGhosthonk@2x.svg',
      poster: 'by Master Ghosthonk',
      played: '90741',
      liked: '6285',
      remixed: '5355',
      borderColor: '#DECDFE',
    },
  ],
};

const redesignData = {
  ...kidsCreatorsData,
  subtitle: '41 million games created and counting',
};

export const getKidsCreatorData = generateVariantData({
  base: redesignData,
  kidsBecomeCreatorsVariant1: kidsCreatorsData,
  kidsBecomeCreatorsVariant2: kidsCreatorsData,
  homepageRedesign: redesignData,
  premiumOndemandClasses: redesignData,
  premiumVsStandardDesign: redesignData,
});



// WEBPACK FOOTER //
// ./src/containers/Home/sections/KidsBecomeCreators/data.js